<template>
  <div class="apresentacoes-editar">
    <Card
      title="Editando Apresentação"
      text="Complete o formulário com as informações do evento"
      v-if="aprSnap !== undefined && fail === false"
      max-width="1000px"
      class="main-card"
    >
      <div class="infofield">
        <v-text-field label="Nome" filled v-model="aprSnap.nome"/>
        <v-text-field label="Organizador" filled v-model="aprSnap.organizador"/>
        <v-text-field label="Código Identificador" filled disabled v-bind:value="aprSnap.codigo"/>
      </div>
      <div class="infofield">
        <v-textarea label="Descrição" filled v-model="aprSnap.descricao"></v-textarea>
        <div v-if="!aprSnap.dataprecisao">
          <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateFormatted"
              label="Data"
              filled
              @blur="dataapr = parseDate(dateFormatted)"
              v-on="on"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker locale="pt-BR" v-model="dataapr" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
        </div>
        <div v-if="aprSnap.dataprecisao">
          <h2 class="label">Data</h2>
          Contate o administrador para alterar a data
        </div>
        <v-checkbox label="Confirmada" v-model="confirmedBox"/>
      </div>
      <div class="infofield">
        <v-divider/>
        <v-text-field label="Repertório (BETA)" hint="Separe as músicas com vírgula sem espaços" persistent-hint filled v-model="repertorioSerializado"/>
      </div>
      <v-divider/>
      <v-btn v-on:click.native="save">Salvar</v-btn>
    </Card>
    <div v-if="apresentacao === undefined && fail === true" class="main-card">
        <h1>Erro</h1>
        Não foi possível encontrar esta apresentação
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { db, Timestamp } from '../main'
import Card from '@/components/Card.vue'

export default {
  name: 'editarapresentacao',
  components: {
    Card
  },
  props: ['apresentacaoid'],
  watch: {
    dataapr (val) {
      this.dateFormatted = this.formatDate(this.dataapr)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month}-${day}`
    },
    save: function (event) {
      console.log('Salvando')
      const aprSnapMod = this.aprSnap
      if (this.confirmedBox === false) aprSnapMod.confirmada = false
      else aprSnapMod.confirmada = true
      if (this.repertorioSerializado === '') {
        delete aprSnapMod.repertorio
      } else {
        aprSnapMod.repertorio = this.repertorioSerializado.split(',')
      }
      const tempDate = new Date(this.dataapr)
      tempDate.setUTCHours(3)
      if (this.dataapr !== '' && !aprSnapMod.dataprecisao) aprSnapMod.data = Timestamp.fromDate(tempDate)
      console.log(aprSnapMod)
      db.collection('apresentacoes')
        .doc(this.dbid)
        .set(aprSnapMod)
        .then(() => {
          console.log('Salvo')
          this.$router.push({ name: 'Detalhes da Apresentação', params: { apresentacaoid: this.apresentacaoid } })
        })
    }
  },
  data () {
    return {
      apresentacao: undefined,
      boundquery: [],
      fail: false,
      apresentacoes: [],
      dbid: String,
      aprSnap: undefined,
      confirmedBox: Boolean,
      menu1: false,
      dataapr: String,
      dateFormatted: '',
      repertorioSerializado: String
    }
  },
  mounted () {
    const queryResult = this.$store.state.apresentacoes.find(x => x.codigo === this.apresentacaoid)
    this.fail = false
    if (queryResult) {
      console.log('Binding Apresentacao from store')
      // this.$unbind('apresentacao')
      this.aprSnap = queryResult
    } else {
      console.log('Binding Apresentacao from database')
      this.$bind('boundquery', db.collection('apresentacoes').where('codigo', '==', this.apresentacaoid)).then(function () {
        console.log(this.boundquery)
        if (!this.boundquery.length) {
          this.fail = true
        } else {
          this.aprSnap = this.boundquery[0]
          this.dbid = this.aprSnap.id
          console.log('conf ' + this.aprSnap.confirmada)
          if (this.aprSnap.confirmada === true) this.confirmedBox = true
          else this.confirmedBox = false
          if (this.aprSnap.data !== undefined) {
            this.dataapr = this.$moment(new Date(this.aprSnap.data.seconds * 1000)).format('YYYY-MM-DD')
          }

          if (this.aprSnap.repertorio) {
            this.repertorioSerializado = this.aprSnap.repertorio.join(',')
          } else {
            this.repertorioSerializado = ''
          }
        }
      }.bind(this))
    }

    if (this.aprSnap) {
      this.dbid = this.aprSnap.id
      console.log('conf ' + this.aprSnap.confirmada)
      if (this.aprSnap.confirmada === true) this.confirmedBox = true
      else this.confirmedBox = false
      if (this.aprSnap.data !== undefined) {
        this.dataapr = this.$moment(new Date(this.aprSnap.data.seconds * 1000)).format('YYYY-MM-DD')
      }

      if (this.aprSnap.repertorio) {
        this.repertorioSerializado = this.aprSnap.repertorio.join(',')
      } else {
        this.repertorioSerializado = ''
      }
    }
  }
}
</script>

<style scoped>
.main-card {
  margin: auto;
}

h1 {
  font-size: 2rem;
  margin-top: 5px;
  margin-bottom: 0px;
  color: black;
}

.label {
  font-size: 1rem;
  font-style: normal;
  margin-bottom: 0.25em;
}

.organizadorfield {
  font-size: 1.5rem;
}

.title {
  margin-bottom: 20px;
}

.adminoptions {
  background: #CCCCCC;
  margin-top: 20px;
  border-radius: 6px;
  padding: 10px;
}

.ul {
  margin-top: 5px;
}

.inviteoptions {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.button::v-deep {
  font-size: 1em;
  height: 2em;
  width: fit-content;
  padding-left: 10px;
  padding-right: 10px;
}
.button {
  margin-top: 10px;
}

</style>
